import { saveIntegration } from '@/features/AudienceManager/services';
export const saveIntegrations = (params) => saveIntegration(params).then(response => formatValue(response.data));
const formatValue = (response) => {
    return response?.success;
};
